import React, {  Component } from 'react'
import ReactDOM from 'react-dom/client';
import avtlogo from "./img/avt.png"; 
import Apprt from './App.js';
//import AdmDashboard from './components/AdminDashboard.js';
import './assets/css/homestyle.css'
import axios from 'axios';
import { removeUserSession, setUserSession,aPIURL,auTHURL } from './utils/common.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CDashboard from './components/ClientApplication/CDashboard.js';
import Modal from './components/LoginModal.js';
import PriceList from './components/PriceList.js';
import PublicNav from './Shared/PublicNav.js'
import PublicFooter from './Shared/PublicFooter.js'
import $ from 'jquery';
import bvideo from './img/AVT-banner.mp4';


class gpstrackingdevice extends React.Component 
{
  
  
  constructor(props) 
  {
    
    super(props);
    
     
  }
  

 

  render() 
  {
   
    
     return (
      <>       

<header id="header" class="">
  <div class="container d-flex align-items-center header-center justify-content-between"> 
  <a href="index.html" class="logo"> <img src="../img/avt.png" alt="AVT" class="img-fluid"/> </a>

  

  <ul class="navbar-nav avt-top-menu collapse" id='topMenu'>
        <li class="nav-item"> <a href="index.html">Home</a> </li>
        <li class="nav-item"> <a href="index.html">Pricing</a> </li>
        <li class="nav-item"> <a href="index.html">Contact</a> </li>
        
      </ul>
    <div class="logo-right-list">
    
    <span></span>
    <span></span>
    <span></span>
    
    <span></span>
    </div>
  </div>
</header>
<section class="pricing topsection">
  <div class="container"> 
  <div class="row"><div class="col-lg-5">
  <h1></h1>
   
    </div></div>
  </div>
</section>
<section class="blog-banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-6">
        <div class="bannerContent">
          <h1 class="bannerHeader">AVT Blog</h1>
        </div>
      </div>
      <div class="col-6"> <img src="../img/blog-banner-1.svg" alt="Blogs" style= {{ margin:"auto", "maxWidth":"400px"}}/> </div>
    </div>
  </div>
</section>
<section class="blog inner pt-60 pb-60">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <div class="blogWrapper shadow">
          <div class="blogImg"> <a href="https://login.avtbharat.com/GPS-tracking-device"> <img src="../img/avt-blog.jpg" alt="GPS Tracking Devices: Used for Safety and Efficiency"/> </a> </div>
          <div class="blogText">
            <h4> GPS Tracking Devices: Used for Safety and Efficiency</h4>
            <ul class="blogDateTime">
              <li><i class="far fa-calendar-alt" aria-hidden="true"></i>Sep 10, 2024</li>
            </ul>
            <p>The fast growth of the transportation industry and vehicles in the country makes it very challenging to manage the management of the transportation industry therefore GPS tracking is one of the best ways to get rid of finding their real-time to know the actual location of vehicles. GPS tracking device is one of the best ways to find and track real-time information about the movement of vehicles and assets. GPS tracking devices communicate with satellites orbiting through the earth, they transmit the receiver and allow them to communicate through the location.</p>
            <p><strong>Benefits of the GPS Tracking devices</strong></p>
            <p><strong>Fleet management efficiency:</strong></p>
            <p>GPS tracking devices play a vital role in logistic companies so the fleet manager can monitor the location and route of their vehicle reduce fuel consumption and improve delivery time .</p>
            <p><strong>Enhanced security and safety: </strong></p>
            <p><strong>Vehicle security:</strong> once the GPS tracking has been installed that can ensure vehicle safety and vehicle owners can monitor the location of their trucks, cars, and bikes and quickly recover them if stolen. </p>
            <p> <strong>Personal safety:</strong> GPS tracking is used for tracking individuals, especially children or any family members and outdoor enthusiasts. </p>
            <p><strong>Assets tracking & management:</strong> GPS trackers are not only used for vehicles but can also use for any assets .</p>
            <p><strong>Cost saving:</strong> With the help of a GPS tracker optimizing the route to save the fuel consumption.</p>
            <p><strong>Peace of Mind:</strong> This is one of the best ways to use it for personal or business purposes to know the location of your loved one, vehicle, or assets management and you can locate them easily. </p>
            <p><strong>The most popular use of GPS Tracking devices:</strong> Personal use for your children information, business use for fleet management or vehicle & outdoor adventures for family member.</p>
            <p><strong>Future of GPS tracking:</strong> As technology continues to become more popular GPS Tracking devices are becoming more advanced and accessible. This can be integrated with smart home devices to improve battery life. </p>
            <p><strong>Conclusion</strong></p>
            <p>GPS tracking devices play a vital role in managing safety and efficiency in your daily life whether for personal or business use, fleet management, or asset management tracking these devices are invaluable and go beyond finding location and are used for security, peace of mind, cost saving & assets management. The capabilities of GPS Tracking and application devices will expand continue and this is an integral part of your life. </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 md-mb-50 pl-35 lg-pl-15 md-order-first">
        <div class="widget shadow">
          <div class="sidebar-title">
            <h3 class="title">Recent Post</h3>
          </div>
          <div class="sidebar-block">
            <div class="sidebar-block-image"> <a href="#"> <img src="../img/avt-blog.jpg" alt="GPS Tracking Devices: Used for Safety and Efficiency"/> </a> </div>
            <div class="sidebar-block-text"> <a href="#">GPS Tracking Devices: Used for Safety and Efficiency </a>
              <ul class="blogDateTime m-0">
                <li><i class="far fa-calendar-alt" aria-hidden="true"></i> 13 September, 2024</li>
              </ul>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</section>








<PublicFooter/>

            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>
    </>
      
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<gpstrackingdevice/>);


export default gpstrackingdevice;